if(typeof require !== 'undefined' && typeof _ === 'undefined'){
  var _ = require('lodash');
}

angular.module('homebot.directives')

.directive('hasFeature', ['ngIfDirective', 'AccountService', function(ngIfDirective, AccountService){
  // Expanding on ngIf directive gives
  // hasFeature all the benefits of ngIf
  // http://stackoverflow.com/a/29010910/580366

  var ngIf = ngIfDirective[0];

  return {
    transclude: ngIf.transclude,
    priority: ngIf.priority - 1,
    terminal: ngIf.terminal,
    restrict: ngIf.restrict,

    link: function(scope, el, attrs){
      var ifEvaluator;
      var initialNgIf = attrs.ngIf;
      var features = attrs.hasFeature.split(',');

      function hasFeature(features){
        return _.every(features, AccountService.hasFeature);
      };

      if(initialNgIf){
        ifEvaluator = function () {
          return scope.$eval(initialNgIf) && hasFeature(features);
        }
      }else{
        ifEvaluator = function () {
          return hasFeature(features);
        }
      }

      attrs.ngIf = ifEvaluator;
      ngIf.link.apply(ngIf, arguments);
    }
  }
}]);
